import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 视图
 */
const view = {
  /**
   * 创建
   */
  createViewTree(
    companyId,
    name,
    displayName,
    measureTemplateGroupRestriction,
    viewTreeReferenceRestriction,
    remark
  ) {
    return axios.post(
      base.view.createViewTree,
      utils.postParamsArrayToJsonString({
        companyId,
        name,
        displayName,
        measureTemplateGroupRestriction,
        viewTreeReferenceRestriction,
        remark,
      })
    );
  },
  /**
   * 修改
   */
  modifyViewTree(
    id,
    name,
    displayName,
    measureTemplateGroupRestriction,
    viewTreeReferenceRestriction,
    remark
  ) {
    return axios.post(
      base.view.modifyViewTree,
      utils.postParamsArrayToJsonString({
        id,
        name,
        displayName,
        measureTemplateGroupRestriction,
        viewTreeReferenceRestriction,
        remark,
      })
    );
  },
  /**
   * 删除
   */
  deleteViewTree(id) {
    return axios.post(
      base.view.deleteViewTree,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询
   */
  getViewTreeInfo(id) {
    return axios.post(
      base.view.getViewTreeInfo,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询
   */
  getCompanyViewTreesInfo(companyId) {
    return axios.post(
      base.view.getCompanyViewTreesInfo,
      utils.postParamsArrayToJsonString({ companyId })
    );
  },
  /**
   * 添加
   */
  addViewNode(viewId, parentId, measureId, orderNum) {
    return axios.post(
      base.view.addViewNode,
      utils.postParamsArrayToJsonString({
        viewId,
        parentId,
        measureId,
        orderNum,
      })
    );
  },
  /**
   * 添加
   */
  addViewNode2(viewId, parentId, measures) {
    return axios.post(
      base.view.addViewNode2,
      utils.postParamsArrayToJsonString({ viewId, parentId, measures })
    );
  },
  /**
   * 添加
   */
  addViewNode3(
    viewId,
    parentId,
    measureName,
    measureRemark,
    measureTemplateId,
    measureSalespersonId,
    measureMountedOn,
    orderNum
  ) {
    return axios.post(
      base.view.addViewNode3,
      utils.postParamsArrayToJsonString({
        viewId,
        parentId,
        measureName,
        measureRemark,
        measureTemplateId,
        measureSalespersonId,
        measureMountedOn,
        orderNum,
      })
    );
  },
  /**
   * 修改
   */
  modifyViewNode(id, parentId, measureId, orderNum) {
    return axios.post(
      base.view.modifyViewNode,
      utils.postParamsArrayToJsonString({ id, parentId, measureId, orderNum })
    );
  },
  /**
   * 删除
   */
  deleteViewNode(id, deleteMeasure) {
    return axios.post(
      base.view.deleteViewNode,
      utils.postParamsArrayToJsonString({ id, deleteMeasure })
    );
  },
  /**
   * 删除
   */
  deleteViewNode2(ids, deleteMeasure) {
    return axios.post(
      base.view.deleteViewNode2,
      utils.postParamsArrayToJsonString({ ids, deleteMeasure })
    );
  },
  /**
   * 查询
   */
  getViewNodeInfo(id) {
    return axios.post(
      base.view.getViewNodeInfo,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询
   */
  getViewTreeNodes(id) {
    // return axios.post(base.view.getViewTreeNodes, utils.postParamsArrayToJsonString({ id }))

    return new Promise((resolve, reject) => {
      axios
        .post(
          base.view.getViewTreeNodesByContainer,
          utils.postParamsArrayToJsonString({ id })
        )
        .then((res) => {
          if (res.data) {
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].id = res.data[i].measureId;
            }
          }
          resolve(res);
        });
    });
  },

  addMeasureContainingItem(viewId, parentId, measureId, orderNum) {
    return axios.post(
      base.view.addMeasureContainingItem,
      utils.postParamsArrayToJsonString({
        viewId,
        parentId,
        measureId,
        orderNum,
      })
    );
  },
  addMeasureContainingItem2(viewId, parentId, measuresId) {
    return axios.post(
      base.view.addMeasureContainingItem2,
      utils.postParamsArrayToJsonString({ viewId, parentId, measuresId })
    );
  },
  addMeasureContainingItem3(
    viewId,
    parentId,
    measureName,
    measureRemark,
    measureTemplateId,
    measureSalespersonId,
    measureMountedOn,
    orderNum
  ) {
    return axios.post(
      base.view.addMeasureContainingItem3,
      utils.postParamsArrayToJsonString({
        viewId,
        parentId,
        measureName,
        measureRemark,
        measureTemplateId,
        measureSalespersonId,
        measureMountedOn,
        orderNum,
      })
    );
  },
  modifyMeasureContainingItem(viewId, parentId = 0, measureId, orderNum) {
    return axios.post(
      base.view.modifyMeasureContainingItem,
      utils.postParamsArrayToJsonString({
        viewId,
        parentId,
        measureId,
        orderNum,
      })
    );
  },
  removeMeasureContainingItems(viewId, measuresId) {
    return axios.post(
      base.view.removeMeasureContainingItems,
      utils.postParamsArrayToJsonString({ viewId, measuresId })
    );
  },
  getViewTreeNodesByContainer(id) {
    // return axios.post('/api/getViewTreeNodesByContainer', utils.postParamsArrayToJsonString({ id }))

    return new Promise((resolve, reject) => {
      axios
        .post(
          base.view.getViewTreeNodesByContainer,
          utils.postParamsArrayToJsonString({ id })
        )
        .then((res) => {
          if (res.data) {
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].id = res.data[i].measureId;
            }
          }
          resolve(res);
        });
    });
  },

  getTree(id) {
    return axios.post(
      base.view.getViewTreeNodes,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  getElectricityConsumption(params) {
    return axios.post(
      "/api/tmp/getElectricityConsumption",
      utils.postParamsArrayToJsonString({ ...params })
    );
  },
  getPowerChart(params) {
    return axios.post(
      "/api/tmp/getPowerChart",
      utils.postParamsArrayToJsonString({ ...params })
    );
  },
};

export default view;
